'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledCssGrid = require('styled-css-grid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
                                                                                                                                                                                                                              * Created by oreuveni
                                                                                                                                                                                                                              * Date: 2019-01-01
                                                                                                                                                                                                                              * Time: 11:56
                                                                                                                                                                                                                              */


var Gallery = function Gallery(_ref) {
    var children = _ref.children,
        rest = _objectWithoutProperties(_ref, ['children']);

    return _react2.default.createElement(
        _styledCssGrid.Grid,
        rest,
        children
    );
};

Gallery.propTypes = {
    columns: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    children: _propTypes2.default.node
};

Gallery.defaultProps = {
    columns: 'repeat(auto-fit,minmax(100px,1fr))'
};

exports.default = Gallery;